import './class-component-hooks'
import Vue from 'vue'
import PortalVue from 'portal-vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import 'swiper/dist/css/swiper.css'

import router from './router'
import store from './store'
import filters from './filters'
import { initSessionWidget } from '@/utils/sessionWidget'
import VueInputAutowidth from 'vue-input-autowidth'

import App from './App.vue'

import './i18n' // register localizations
import './analytics' // register web analytics plugin
import './ui_content'
import './declension'

// Prevent application launch without browser validity confirmation
if (window.validBrowser) {
  initSessionWidget()

  dayjs.extend(utc)

  Vue.config.productionTip = false
  Vue.use(PortalVue)
  Vue.use(VueInputAutowidth)

  // set available global filters
  Object.entries(filters).map(([key, value]) => {
    Vue.filter(key, value)
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
